// Typography rules (see src/design-system/TYPOGRAPHY_AND_THEME.md):
//   - Every title uses a typography.h* preset, OR `font-heading font-bold` directly.
//   - Body text inherits --font-body automatically; do not set fontFamily.
import React from "react";
import { typography } from "../../design-system/tokens";
import {
  affiliateSecondaryButtonInner,
  affiliateSecondaryButtonWrapper,
} from "../utils/uiClasses";

/**
 * Supporting action in the affiliate portal: pale fill, purple→pink gradient
 * border, purple label — the quieter counterpart to AffiliatePrimaryButton.
 *
 * The gradient border needs two elements (a gradient-filled wrapper with a 1px pad
 * around a pale inner surface), so this is a wrapper around the real <button>
 * rather than a single styled element.
 */
const AffiliateSecondaryButton = ({
  children,
  fullWidth = false,
  className = "",
  ...buttonProps
}) => (
  <span
    className={`${affiliateSecondaryButtonWrapper} inline-flex ${fullWidth ? "w-full" : ""} ${className}`}
  >
    <button
      type="button"
      {...buttonProps}
      className={[
        affiliateSecondaryButtonInner,
        typography.bodySmall,
        "font-medium px-3 py-1.5",
        fullWidth ? "w-full" : "",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "focus:outline-none focus:ring-2 focus:ring-pink-400 dark:focus:ring-pink-300",
      ].join(" ")}
    >
      {children}
    </button>
  </span>
);

export default AffiliateSecondaryButton;
